import React from 'react';
import PropTypes from 'prop-types';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Update state to ensure fallback UI renders
    this.setState({ hasError: true });
    // eslint-disable-next-line no-console
    console.error('Error caught by error boundary:', error, info);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-100">
          <div className="bg-white p-10 rounded-2xl shadow-lg text-center max-w-sm w-full">
            <div className="text-5xl text-red-500 mb-4">
              <span role="img" aria-label="Error">❌</span>
            </div>
            <h2 className="mb-3 font-semibold text-2xl text-gray-900">
              Something went wrong
            </h2>
            <p className="text-gray-600 mb-6 text-base">
              Sorry, an unexpected error has occurred. Please try reloading the page.
            </p>
            <button
              type="button"
              onClick={this.handleReload}
              className="bg-red-500 hover:bg-red-600 text-white rounded-lg px-6 py-2 text-base font-medium shadow transition-colors duration-200"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;